module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponNav"
  }, [_c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      class: _vm.actionFn === index ? 'actionLi' : ''
    }, [_c('router-link', {
      attrs: {
        "to": item.router
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8a7b76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/couponNav/src/couponNav.vue
// module id = 531
// module chunks = 0